import { getLogoUrl } from './getLogoUrl';

export function getDarkLogoUrl(
  fileName?: string,
  fallback?: string,
): string | undefined {
  const darkLogo = getLogoUrl(fileName);

  return darkLogo ?? fallback;
}
